import { render, staticRenderFns } from "./CronogramaAcoes.vue?vue&type=template&id=2596530b&scoped=true&"
import script from "./CronogramaAcoes.vue?vue&type=script&lang=js&"
export * from "./CronogramaAcoes.vue?vue&type=script&lang=js&"
import style0 from "./CronogramaAcoes.vue?vue&type=style&index=0&id=2596530b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596530b",
  null
  
)

export default component.exports